module.exports = "<div *ngIf=\"instance_project_type != ''\" class=\"instance-type\"><b>{{instance_project_type}}</b></div>"